import isFileImage from 'src/features/product/product-detail/utils/isFileImage';
import { DomainUploadedFile } from 'src/shared/types/uploadedFile';

// backend/uploadedfiles/models.py > PRODUCT_PHOTO_TAG
export const PRODUCT_PHOTO_TAG = 'tag:product_photo';

/**
 * The shipment files staff marked as product photos, which are shown with the
 * sample's or example item's own photos (they also stay in its files).
 */
const getShipmentProductPhotos = (
  shipmentFiles: DomainUploadedFile[] | undefined
): DomainUploadedFile[] =>
  (shipmentFiles ?? []).filter(
    (file) => file.tags.includes(PRODUCT_PHOTO_TAG) && isFileImage(file)
  );

export default getShipmentProductPhotos;
